import * as React from 'react';
import * as moment from 'moment';

// utils
import { translate } from 'components/translate-hoc';
import { getModeClass } from 'utils/css';
// styles
import './soft-closing-block.less';
// types
import { ISoftClosingBlockProps } from './soft-closing-block.types';
// constants
import { TEXT_KEYS_BY_VIEW } from './soft-closing-block.constants';
// assets
import IconClock from '../../assets/clock.svg';

export const SoftClosingBlock = (props: ISoftClosingBlockProps): JSX.Element => {
    const { dangerouslyTranslateWithHTML: translateKey, currentView, endDate, shouldInheritStyles } = props;
    return (
        <div className={getModeClass('sitegen-friend-referral-soft-closing-block', shouldInheritStyles)}>
            <img src={IconClock} alt="" />
            {translateKey(TEXT_KEYS_BY_VIEW[currentView], { endDate: moment(endDate).format('MMMM DD, YYYY') })}
        </div>
    );
};

export default translate()(SoftClosingBlock);
